import mixpanel from 'mixpanel-browser'

mixpanel.init('38e2cda6b2c19c963053597f41b6ee33', {
  debug: process.env.NODE_ENV === 'development' ? true : false,
})

export default mixpanel
